'use strict';

/**
 * Popover
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.Popover = T.createModule({

	_selectors: {
		popoverContent: '[data-js-m-popover-content]',
		closeButton: '[data-js-m-popover-close-button]'
	},

	_stateClasses: {
		open: 'state-open'
	},

	_eventNames: {
		close: 'popover-close',
		closeCallback: 'popover-close-callback',
		open: 'popover-open'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this.$popoverContent = this.$ctx.find(this._selectors.popoverContent);
		this.$closeButton = this.$ctx.find(this._selectors.closeButton);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));
		this._events.on('viewport.match', this.onViewportMatch.bind(this));
		this._events.on(this._eventNames.close, this.onPopoverClose.bind(this));
		this._events.on(this._eventNames.open, this.onPopoverOpen.bind(this));

		this.$closeButton.on('click', this.onPopoverCloseButton.bind(this));

		this.popper = null;
		this.isDesktop = false;

		// needed sinc ios devices do not detect a click on the document otherwise, http://stackoverflow.com/a/18991055
		if (Modernizr.ios) {
			$('*').css('cursor', 'pointer');
		}

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {},
	addEventListener: function addEventListener() {
		$(document).on('click.popover', this.onClickDocument.bind(this));
		$(document).on('keyup.popover', this.onClickEsc.bind(this));
	},


	/**
  * Destroy the popover and remove state classes and listeners
  *
  * @returns {void}
  */
	destroyPopover: function destroyPopover() {
		if (this.popper !== null) {
			this.$ctx.removeClass(this._stateClasses.open);
			this.popper.destroy();

			this.$popoverContent.empty();

			$(document).off('click.popover');
			$(document).off('keyup.popover');

			this._events.emit(this._eventNames.closeCallback, {
				$trigger: this.$trigger
			});

			this.$trigger = null;
			this.popper = null;
		}
	},


	/**
  * Event when the user clicks on the document outside the popover
  *
  * @param {Event} ev The click event
  * @returns {void}
  */
	onClickDocument: function onClickDocument(ev) {
		var $target = $(ev.target);

		if (!$target.closest(this.$ctx).length) {
			ev.preventDefault();
			this.destroyPopover();
		}
	},


	/**
  * Event when the user hits the esc key
  *
  * @param {Event} ev The keyup event
  * @returns {void}
  */
	onClickEsc: function onClickEsc(ev) {
		if (ev.which === 27) {
			ev.preventDefault();
			this.destroyPopover();
		}
	},


	/**
  * Event when the a popover should close
  *
  * @returns {void}
  */
	onPopoverClose: function onPopoverClose() {
		this.destroyPopover();
	},


	/**
  * Event when the a popover should close
  *
  * @param {Event} ev The click event
  * @returns {void}
  */
	onPopoverCloseButton: function onPopoverCloseButton(ev) {
		ev.preventDefault();
		this.destroyPopover();
	},


	/**
  * Event when the a popover should open
  *
  * @param {Object} eventData The event data containing the trigger and the popover content
  * @returns {void}
  */
	onPopoverOpen: function onPopoverOpen(eventData) {

		// destroy possible previous popover instance
		this.destroyPopover();

		this.$ctx.addClass(this._stateClasses.open);
		this.$trigger = eventData.$trigger;

		this.$popoverContent.append(eventData.content);

		this.popper = new Popper(eventData.$trigger.get(0), this.$ctx.get(0), {
			placement: 'bottom',
			flipBehavior: ['bottom', 'top', 'left', 'right'],
			boundariesElement: this.$ctx.parent().get(0),
			boundariesPadding: 10,
			modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', this.getPopoverOffset.bind(this), 'applyStyle']
		});

		this.$popoverContent.focus();

		this.popper.onCreate(this.addEventListener.bind(this));
	},


	/**
  * Custom modifier to reset the offset of the popover for small screen, since we want it to cover the whole image
  *
  * @param {Object} popperData The popper config object
  * @returns {Object} popperData The popper config object
  */
	getPopoverOffset: function getPopoverOffset(popperData) {
		if (!this.isDesktop) {
			popperData.offsets.popper.top = 0;
			popperData.offsets.popper.left = 0;
		}
		return popperData;
	},


	/**
  * Event from enquire when a certain viewport is detected
  *
  * @param {Object} wpName The detected viewport.
  * @returns {void}
  */
	onViewportMatch: function onViewportMatch(wpName) {
		switch (wpName) {
			case 'small-down':
				this.isDesktop = false;
				break;
			case 'medium-up':
				this.isDesktop = true;
				break;
			default:
				break;
		}
	}
});